import Reveal from '@/components/base/Reveal';
import { stories } from '@/mocks/home';

export default function StoriesSection() {
  return (
    <section id="stories" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-4 border-b border-background-300 pb-6">
          <div>
            <span className="text-xs md:text-sm tracking-[0.2em] text-primary-600">STORIES · 经历与细节</span>
            <h3 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">他们的被困与逃生细节</h3>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-6">
            四段经过整理的<strong className="font-semibold text-foreground-900">缅北黑料自述</strong>，呈现从被骗到脱身的关键片段。
          </p>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {stories.map((story, index) => (
            <Reveal key={story.name + story.place} delay={index * 70}>
              <article className="group h-full rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
                <div className="w-full h-[190px] sm:h-[210px] overflow-hidden bg-background-200">
                  <img
                    src={story.img}
                    alt={`${story.name} 的缅北黑料亲历者口述经历配图`}
                    title={`缅北黑料受害者 ${story.name} 经历自述`}
                    className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-700"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-3">
                    <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm font-semibold">
                      {story.name.slice(0, 1)}
                    </span>
                    <div>
                      <h4 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-none">
                        {story.name}
                      </h4>
                      <p className="mt-1 text-xs text-foreground-500">{story.meta}</p>
                    </div>
                  </div>
                  <div className="mt-4 inline-flex items-center gap-1.5 text-xs text-accent-700">
                    <i className="ri-map-pin-2-line"></i>
                    {story.place}
                  </div>
                  <p className="mt-3 text-sm leading-7 text-foreground-600">{story.summary}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {story.tags.map((tag) => (
                      <span key={tag} className="text-[11px] px-2 py-1 rounded-full bg-secondary-100 text-secondary-900">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}